__webpack_require__.p = "https://storage.atlasplan.com/public/frontend/20231206_140328_production/assets/";